export default __webpack_public_path__ + "static/media/megawide_banner.e53f2700.png";